<template>
  <v-card flat>
    <v-card-text>
      <v-text-field autocomplete="new-password" label="search other vimeo accounts" v-model="vimeoUserSearchModel"
        @change="vimeoUserSearchChange" clearable />
      <template v-slot:append>
        <v-icon @click.stop="vimeoUserSearchChange">search</v-icon>
      </template>
      <template>
        <v-progress-linear v-if="showUserProgress" :indeterminate="true" color="accent" :active="showUserProgress"
          height="2"></v-progress-linear>
      </template>
      <v-chip-group column>
        <v-chip label class="squeeze" v-for="(item, i) in vimeoFoundChipData" :key="i"
          @click="vimeoUserSelectedIDChange($event, item)" :color="accountChipColor(item)" small>
          <v-avatar>
            <img :src="item.pic.link">
          </v-avatar>
          <span class="ml-1">{{ item.name }}</span>
        </v-chip>
      </v-chip-group>

    </v-card-text>

    <v-card-text>
      <v-text-field autocomplete="new-password" v-model="vimeoVideoSearchModel"
        :label="`search for videos in vimeo account ${selectedAccount && selectedAccount.name}`"
        @change="vimeoVideoSearchChange" ref="vimeosearch" clearable>
        <template v-slot:append>
          <v-icon @click.stop="vimeoVideoSearchChange">search</v-icon>
        </template>
      </v-text-field>
    </v-card-text>

    <v-card-text v-if="selectedAccount && !loading" dense cols="12">
      <v-row>

        <v-col cols="auto">
          <v-switch v-model="doAutoLabelling" label="Auto label new films" :disabled="!totalItems"></v-switch>
        </v-col>

        <v-col cols="auto">
          <v-switch v-model="doCreateVerification" label="Film creation verification check" :disabled="!totalItems">
          </v-switch>
        </v-col>

        <v-col cols="auto">
          <v-switch v-model="showNavFilm" label="Show film after adding" :disabled="!totalItems"></v-switch>
        </v-col>

      </v-row>

      <v-row>
        <v-col cols="11"><span class="title">
            <span v-if="showViLabelStats">Hide</span><span v-else>Show</span> Labelling Statistics
          </span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col>
          <v-btn icon @click="showViLabelStats = !showViLabelStats">
            <v-icon :color=showIconColor>{{ showIcon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <vi-label-stats v-if="showViLabelStats">
        </vi-label-stats>
      </v-row>
      <v-row>

        <v-col cols="auto">
          <span v-if="totalItems">
            Loaded {{ totalFetched }}/{{ totalItems }} films
          </span>
          <span v-else>
            No
          </span>
          <span>
            matching videos in account {{ selectedAccount.name }} ({{ selectedAccount.id }})
          </span>
        </v-col>


      </v-row>
    </v-card-text>
    <v-card-text v-else-if="showProgress">
      <v-row dense>
        <v-progress-linear :indeterminate="true" color="accent" :active="showProgress" height="2"></v-progress-linear>
      </v-row>
    </v-card-text>
    <big-content v-if="userVideoItem && totalFetched" :row-types="rowTypes" :item="userVideoItem"></big-content>

    <video-count-chip :loading="loading" :totalItems="totalItems" :totalFetched="totalFetched"></video-count-chip>

    <infinite-loading v-if="needScrolling" :distance="scrollDistance" @infinite="scrollMore">
      <template v-slot:spinner>
        <v-progress-linear :active="showProgress" :indeterminate="true" color="accent" height="2"></v-progress-linear>
      </template>
      <template v-slot:no-more><span></span></template>
      <template v-slot:no-results><span v-if="!totalFetched">"no videos found"</span><span v-else></span></template>
    </infinite-loading>

  </v-card>
</template>
<script>
import { vxMaps } from "@/js/vxstore";
import { settings, getIconColor, getIcon } from '@/js/store'
import { SearchUtils } from '@/js'
import { VimeoUserVideosInfo, Controls, VimeoUserSearch, FilmMasterVimeoPatch } from '@/gql'
import Bigcontent from '@/components/Bigcontent'
import Vilabelstats from '@/components/Vilabelstats'
import Videocountchip from '@/components/Videocountchip'
import InfiniteLoading from 'vue-infinite-loading'
import { mergeControls } from '@/js/apollo'
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    'big-content': Bigcontent,
    'video-count-chip': Videocountchip,
    'infinite-loading': InfiniteLoading,
    'vi-label-stats': Vilabelstats
  },
  props: {
    vimeoUserItem: {
      type: Object,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  watch: {
    addedFilms() {
      // anything in here thats ready can be patched to render the new filmmaster info
      const patching = this.addedFilms.filter(f => f.ready)
      if (patching.length) {
        return Promise.all(patching.map(f => {
          this.setAddedFilm({ ...f, ready: false })
          return this.patchVimeoVideosInfo(f).then((this.removeAddedFilm(f)))
        }))
      }
    },
  },
  methods: {
    patchVimeoVideosInfo(addedFilm) {

      return this.$apollo.query({
        query: FilmMasterVimeoPatch,
        variables: {
          id: addedFilm.filmMasterID
        },
        fetchPolicy: 'no-cache',
      }).then(result => {
        // now we need to patch up the rendering data
        const master = result.data.FilmMaster
        // find this one
        const index = this.VimeoUserVideosInfo.VimeoVideoInfos.findIndex(f => f.id === master.hostID)
        if (index === -1) throw 'couldnt find vimeoid in rendered list:' + master.hostID
        const n = this.VimeoUserVideosInfo.VimeoVideoInfos[index]
        n.FilmMastersFromVimeoID = [master]
        this.VimeoUserVideosInfo.VimeoVideoInfos.splice(index, 1, n)
      })

    },
    accountChipColor(item) {
      return getIconColor('vimeouser', !this.vimeoUserSelectedID || item.id !== this.vimeoUserSelectedID)
    },
    clearVideos() {
      this.userVideoItem = null
      this.totalFetched = 0
      this.VimeoUserVideosInfo = null
    },
    clearUser() {
      mergeControls({
        vimeoUserSelectedID: null
      })
    },
    vimeoUserSelectedIDChange(e, item) {
      // need to reset the scroller if the search changes
      this.clearVideos()
      this.vimeoVideoSearchModel = null
      mergeControls({
        vimeoUserSelectedID: item.id,
        vimeoVideoSearchText: this.vimeoVideoSearchModel
      })
    },
    vimeoUserSearchChange() {
      this.clearUser()
      mergeControls({
        vimeoUserSearchText: this.vimeoUserSearchModel
      })
    },
    vimeoVideoSearchChange() {
      // need to reset the scroller if the search changes
      this.clearVideos()
      // TODO .. check whats this for
      if (this.$refs.vimeosearch) {
        this.$refs.vimeosearch.blur()
      }
      mergeControls({
        vimeoVideoSearchText: this.vimeoVideoSearchModel
      })
    },

    scrollMore(scrollState) {
      const offset = this.totalFetched
      if (offset >= this.totalItems) {
        scrollState.loaded()
        scrollState.complete()
        return null
      }

      // start getting more
      const { $apollo, queryVars } = this
      const { queries } = $apollo
      this.gettingMore = true

      return queries.VimeoUserVideosInfo.fetchMore({
        variables: {
          ...queryVars,
          limit: settings.pagination.limit,
          offset
        },

        updateQuery: (previousResult, { fetchMoreResult }) => {
          // the newly returned data
          const newData = fetchMoreResult.VimeoUserVideosInfo.VimeoVideoInfos

          // what we already have
          const chunk = (previousResult && previousResult.VimeoUserVideosInfo.VimeoVideoInfos) || []

          // its not a pure append, because its possoble we've paged beyond what we already have
          Array.prototype.splice.apply(chunk, [offset, 0].concat(newData))

          // reconstruct a full result, but with the additional data and resgister
          const result = {
            totalItems: fetchMoreResult.VimeoUserVideosInfo.totalItems,
            VimeoVideoInfos: chunk.slice()
          }

          // using object assign to inherit the object details from the original request
          const ob = Object.assign({}, previousResult, result)

          this.gettingMore = false
          scrollState.loaded()
          return ob
        }
      })
    },

    registerResult({ info }) {
      // TODO - we're using an update query here so this isnt going to work to segreate new and old films
      // its the query itself that needs to be attacked
      // so we'll need some changes in the server end
      this.totalFetched = (info && info.VimeoVideoInfos && info.VimeoVideoInfos.length) || 0

      // package up the user info and the video info
      const s = info && SearchUtils.combineSearcherVimeoUserVideos({
        userItem: this.vimeoUserItem,
        userVideosInfo: info.VimeoVideoInfos
      })

      this.userVideoItem = s
      this.VimeoUserVideosInfo = info
    },
    ...mapMutations(vxMaps.mutations),
  },
  data: () => ({
    scrollDistance: settings.pagination.scrollDistance,
    gettingMore: false,
    VimeoUserVideosInfo: null,
    VimeoUserSearch: null,
    rowTypes: ['vimeofilm'],
    userVideoItem: null,
    totalFetched: 0,
    Controls: null,
    vimeoUserSearchModel: null,
    vimeoVideoSearchModel: null
  }),
  created() {
    this.vimeoVideoSearchModel = this.vimeoVideoSearchText
    this.vimeoUserSearchModel = this.vimeoUserSearchText
  },
  computed: {
    showIcon() {
      return getIcon(this.showViLabelStats ? 'hide' : 'show')
    },
    showIconColor() {
      return getIconColor(this.showViLabelStats ? 'hide' : 'show')
    },
    showViLabelStats: {
      get() {
        return this.Controls && this.Controls.showViLabelStats
      },
      set(value) {
        mergeControls({
          showViLabelStats: value
        })
      }
    },
    showNavFilm: {
      set(value) {
        mergeControls({
          vimeoNavigateAfterAdd: value
        })
      },
      get() {
        return this.Controls.vimeoNavigateAfterAdd
      }
    },
    doCreateVerification: {
      set(value) {
        mergeControls({
          createVerification: value
        })
      },
      get() {
        return this.Controls && this.Controls.createVerification
      }
    },
    doAutoLabelling: {
      set(value) {
        mergeControls({
          autoFilmLabelling: value
        })
      },
      get() {
        return this.Controls && this.Controls.autoFilmLabelling
      }
    },
    needScrolling() {
      return this.totalItems && this.totalFetched >= settings.pagination.vimeoInitialLimit && this.totalFetched < this.totalItems
    },
    queryVars() {
      // query construction
      const q = {
        id: this.userId,
        vimeoID: this.vimeoUserSelectedID,
        limit: settings.pagination.vimeoInitialLimit,
        value: this.vimeoVideoSearchText
      }
      return q
    },
    // the inherited seach value
    vimeoUserSearchText() {
      return this.Controls && this.Controls.vimeoUserSearchText
    },
    vimeoVideoSearchText() {
      return this.Controls && this.Controls.vimeoVideoSearchText
    },
    vimeoUserSelectedID() {
      return (this.Controls && this.Controls.vimeoUserSelectedID) || this.vimeoDefaultUserID
    },
    vimeoUser() {
      return this.vimeoUserItem &&
        this.vimeoUserItem.itemReason &&
        this.vimeoUserItem.itemReason.VimeoUser
    },
    vimeoDefaultUserID() {
      return this.vimeoUser && this.vimeoUser.id
    },
    // the currently selected account is all the known chip data searched for the selected ID
    // the selectedID has either just been selected or remembered in persistent apollo cache
    selectedAccount() {
      return (this.vimeoFoundChipData &&
        this.vimeoFoundChipData.find(f => f.id === this.vimeoUserSelectedID)) || null
    },
    // this the chip data for the logged in users own vimeo account
    // using the lowest resolution picture
    vimeoDefaultChipData() {
      const { name, pictures, id } = this.vimeoUser
      return {
        name,
        pic: pictures.sizes[0],
        id
      }
    },
    // this is all the chip data found by matching the user search
    // plus the users own vimeo user info
    // with dup removed
    vimeoFoundChipData() {
      if (this.vimeoFoundUsers) {
        return [this.vimeoDefaultChipData]
          .concat((this.vimeoFoundUsers || []).map(f => ({
            name: f.name,
            pic: f.pictures.sizes[0],
            id: f.id
          })))
          .filter((f, i, a) => a.findIndex(g => g.id === f.id) === i)
      } else {
        return [this.vimeoDefaultChipData]
      }
    },
    // this is all the vimeo users matching amy search thats been done
    vimeoFoundUsers() {
      return this.VimeoUserSearch && this.VimeoUserSearch.VimeoUserInfos
    },
    // these are the total number of videos for the selected user
    totalItems() {
      return (this.VimeoUserVideosInfo && this.VimeoUserVideosInfo.totalItems)
    },
    loading() {
      return this.$apollo.loading
    },
    showProgress() {
      return this.loading && this.gettingMore
    },
    showUserProgress() {
      return this.loading && !this.VimeoUserSearch
    },
    vimeoUserItemReason() {
      return this.vimeoUserItem && this.vimeoUserItem.itemReason
    },
    ...mapState(vxMaps.state),
  },
  apollo: {
    Controls: {
      query: Controls
    },
    VimeoUserSearch: {
      skip() {
        const skip = !this.userId || !this.vimeoUserSearchText
        return skip
      },
      query: VimeoUserSearch,
      fetchPolicy() {
        return 'no-cache'
      },
      variables() {
        const vars = {
          id: this.userId,
          limit: settings.pagination.vimeoUserSearchLimit,
          offset: 0,
          value: this.vimeoUserSearchText
        }
        return vars
      }
    },
    VimeoUserVideosInfo: {
      skip() {
        const skip = !this.Controls || !this.userId || !this.vimeoUserSelectedID
        return skip
      },
      query: VimeoUserVideosInfo,
      result(r) {
        const info = r && r.data && r.data.VimeoUserVideosInfo
        this.registerResult({ info })
      },
      variables() {
        return this.queryVars
      }
    }
  }
}
</script>
